import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export type JurisprudenceTab = 'search' | 'follows' | 'alerts';

const TABS: Array<{ key: JurisprudenceTab; label: string; path: string }> = [
  { key: 'search', label: 'Recherche', path: '/jurisprudences' },
  { key: 'follows', label: 'Mes suivis', path: '/jurisprudences/suivi' },
  { key: 'alerts', label: 'Centre d’alertes', path: '/jurisprudences/alertes' },
];

interface Props {
  active: JurisprudenceTab;
}

const JurisprudenceTabs: React.FC<Props> = ({ active }) => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="flex border-b border-gray-200 dark:border-gray-600 mb-6 overflow-x-auto">
      {TABS.map(tab => {
        const isActive =
          tab.key === active ||
          (tab.key === 'follows' && location.pathname === '/jurisprudences/suivi');
        return (
          <button
            key={tab.key}
            onClick={() => navigate(tab.path)}
            className={`px-6 py-3 text-sm font-medium border-b-2 transition-colors duration-200 whitespace-nowrap ${
              isActive
                ? 'border-mcdm-third-300 text-mcdm-third-500 dark:border-mcdm-primary-100 dark:text-mcdm-primary-100'
                : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'
            }`}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
};

export default JurisprudenceTabs;
